module.exports = __webpack_public_path__ + "img/noruego.2a01fd31.svg";